import _extends from "@babel/runtime/helpers/extends";
import { CoreDomainSearchBaseLayout } from '@wix/core-domain-search';
import { Box, Button } from '@wix/design-system';
import { ChevronRight } from '@wix/wix-ui-icons-common/lazy';
import clsx from 'clsx';
import React, { useCallback, useMemo } from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './resultsSearchBarV4.scss';
const CONTAINER_MAX_WIDTH = '980px';
export const V4_SEARCH_BAR_PLACEHOLDER_KEY = 'domains_search_gate.new_searchbar.placeholder';
const SearchContainer = _ref => {
  let {
    children,
    className,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    direction: "vertical",
    backgroundColor: "#FFFFFF",
    width: "100%",
    maxWidth: CONTAINER_MAX_WIDTH,
    zIndex: 1
  }, props, {
    className: clsx(s.searchContainer, className)
  }), children);
};
const StatusContainer = props => /*#__PURE__*/React.createElement(CoreDomainSearchBaseLayout.StatusContainer, _extends({}, props, {
  maxWidth: CONTAINER_MAX_WIDTH
}));
const InputContainer = _ref2 => {
  let {
    children,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(Box, _extends({
    direction: "horizontal",
    verticalAlign: "middle",
    align: "space-between",
    width: "100%",
    padding: "12px",
    flex: 1,
    gap: "SP1"
  }, props), children);
};
const ToolBarContainer = () => /*#__PURE__*/React.createElement(React.Fragment, null);
export const useResultsSearchBarV4Layouts = () => {
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const ActionButton = useCallback(_ref3 => {
    let {
      children: _icon,
      size: _size,
      priority: _priority,
      ...props
    } = _ref3;
    return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
      size: "large",
      skin: "dark",
      priority: "secondary",
      suffixIcon: /*#__PURE__*/React.createElement(ChevronRight, null),
      className: clsx(s.actionButton, props.className)
    }), t('domains_search_gate.gate_revamp.searchbar.submit.cta'));
  }, [t]);
  return useMemo(() => ({
    SearchContainer,
    StatusContainer,
    InputContainer,
    ActionButton,
    ToolBarContainer
  }), [ActionButton]);
};
//# sourceMappingURL=resultsSearchBarV4Layouts.js.map